// @flow
import {APICore} from './apiCore';

const api = new APICore();

function ApiGetAllThreatment(params: any): any {
  const baseUrl = '/api/admin/threatment';
  return api.get(`${baseUrl}`, params);
}

function ApiGetReportThreatment(params: any): any {
  const baseUrl = '/api/admin/threatment_order';
  return api.get(`${baseUrl}`, params);
}
function ApiGetReportTglThreatment(params: any): any {
  const baseUrl = '/api/admin/threatment_order/report';
  return api.get(`${baseUrl}`, params);
}
function ApiPrintPdfThreatment(params: any): any {
  const baseUrl = '/api/admin/threatment_order/report/pdf';
  return api.getFile(`${baseUrl}`, params);
}
function ApiPrintExcelThreatment(params: any): any {
  const baseUrl = '/api/admin/threatment_order/report/excel';
  return api.getFile(`${baseUrl}`, params);
}

function ApiGetReportTerapisThreatment(params: any): any {
  const baseUrl = '/api/admin/transaksireflexy/feethreatment';
  return api.get(`${baseUrl}`, params);
}

function ApiPostThreatment(params: any): any {
  const baseUrl = '/api/admin/threatment';
  // console.log('🚀 ~ ApiPostFasilitas ~ params:', params);
  return api.create(`${baseUrl}`, params);
}

function ApiEditThreatment(params: any, id: any): any {
  const baseUrl = '/api/admin/threatment/' + id;
  return api.update(`${baseUrl}`, params);
}
function ApiDeleteThreatment(id: any): any {
  const baseUrl = '/api/admin/threatment/' + id;
  return api.delete(`${baseUrl}`);
}

export {
  // ApiGetAllKategoriMenu,
  ApiGetAllThreatment,
  ApiGetReportThreatment,
  ApiGetReportTerapisThreatment,
  ApiGetReportTglThreatment,
  ApiPostThreatment,
  ApiPrintPdfThreatment,
  ApiEditThreatment,
  ApiPrintExcelThreatment,
  ApiDeleteThreatment,
};
